
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import PreschoolMyGroupsContent from "./components/PreschoolMyGroupsContent.vue";

export default defineComponent({
  name: "MyGroupsContentPage",
  components: {
    BreadCrumb,
    PreschoolMyGroupsContent,
  },
});
